import './assets/index.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import * as Sentry from '@sentry/vue'
import FeStealie from '@get-overalls/fe-stealie'

const app = createApp(App)

// eslint-disable-next-line
if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    app,
    dsn: 'https://22bab97f026b4075a0bc6eb7466b5770@o1081935.ingest.us.sentry.io/4506996118061056',
    denyUrls: ['localhost:5173'],
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false
      })
    ],
    // Performance Monitoring
    tracesSampleRate: 0.1, //  Capture 10% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    //tracePropagationTargets: ["localhost", /^https:\/\/althea\.overa\/api/],
    // Session Replay
    replaysSessionSampleRate: 0, // Don't capture session replays if there aren't any errors
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })
}

app.use(createPinia())
app.use(FeStealie)
app.use(router)

app.mount('#app')
